import LoadingCircle from "reports/components/simple/LoadingCircle";
import EOSReport from "../../../../components/Reports/EOSReport";
import NWSummaryMetrics from "./NWSummaryMetrics";
import { isEmpty } from "lodash";
import MetricAndPnLBreakdowns from "../../../../components/Reports/GenericCharts/MetricAndPnLBreakdowns/MetricAndPnLBreakdowns";
import PnLChart from "../../../../components/Reports/GenericCharts/PnLChart/PnLChart";
import { getPnlTimesWithProducingLosses } from "../../../../components/Reports/GenericCharts/PnLChart/pnlChartUtils";
import { useProcessGroupNameAndMachemetryIds } from "../../../../components/Reports/reportUtils";
import useEosData from "reports/store/useEosData";
import { MetricEnum } from "reports/utils/metricTypes";
import { SummaryMetricInput } from "reports/utils/metricUtils";
import { PnlBreakdown } from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { ONE_HOUR_OF_MS } from "reports/utils/timeUtils";

export default function NWEos() {
  const { processGroupName } = useProcessGroupNameAndMachemetryIds({
    defaultProcessGroupName: "All Machines",
  });

  const machemetryIds = [
    "naturesway_d_001",
    "naturesway_d_005",
    "naturesway_d_006",
    "naturesway_d_007",
  ];

  // EOS needs ge and lt url params, sample is January 4th 2021, 6AM - 4PM
  const sampleLink = `?ge=1609758000000&lt=1609794000000`;

  return (
    <EOSReport
      machemetryIds={machemetryIds}
      sampleLink={sampleLink}
      flightTimelineLinkGroup={"All"}
      flightDashboardLinkGroup={"All"}
      showTrendsForMultiDay={true}
      shouldShowPrint={false}
    >
      <NWEosComponents {...{ processGroupName, machemetryIds }} />
    </EOSReport>
  );
}

function NWEosComponents({ processGroupName, machemetryIds }) {
  const { data } = useEosData();

  return data && !isEmpty(data) ? (
    <>
      <NWSummaryMetrics {...{ data, processGroupName }} />
      <PnLChart pnlTimes={getPnlTimesWithProducingLosses({ data })} />
      <MetricAndPnLBreakdowns
        {...{
          machemetryIds,
        }}
        shouldHideLess={false}
        getCustomSummaryMetricsInputListWithPnlBreakdown={data =>
          getCustomSummaryInputMetricListWithPnlBreakdown({
            data,
          })
        }
      />
    </>
  ) : (
    <LoadingCircle
      logAfterTimeout={{
        logData: { eosData: data, machemetryIds },
        delay: 5 * 1000,
      }}
    />
  );
}

export const getCustomSummaryInputMetricListWithPnlBreakdown = ({
  data,
}: {
  data: PnlBreakdown;
}): SummaryMetricInput[] => {
  const summaryMetricsInputList = [
    { name: MetricEnum.OEE },
    { name: MetricEnum.PERF },
    { name: MetricEnum.AVAIL },
    { name: MetricEnum.COUNT },
    {
      name: MetricEnum.GROSS_COUNT,
      title: "Avg. Rate",
      customValue:
        data.grossOutput && data.productionTime
          ? data.grossOutput / (data.productionTime / ONE_HOUR_OF_MS)
          : 0,
      unit: " / hr",
    },
    {
      name: MetricEnum.GROSS_COUNT,
      title: "Avg. Run Rate",
      customValue:
        data.grossOutput && data.producing.durationMs
          ? data.grossOutput / (data.producing.durationMs / ONE_HOUR_OF_MS)
          : 0,
      unit: " / hr",
    },
  ];
  return summaryMetricsInputList;
};
